import PageHero from "@/components/common/PageHero";

const sections = [
  { h: "Information We Collect", b: "We collect information you provide directly (name, email, company details when you submit forms), as well as analytics data such as IP address, browser type, and pages visited via standard cookies." },
  { h: "How We Use Your Information", b: "To respond to your inquiries, schedule strategy calls, deliver requested audits, send newsletters (with your consent), and improve our services." },
  { h: "Data Sharing", b: "Kavion Global Limited does not sell your personal data. We share information only with trusted service providers (analytics, email, CRM) under strict confidentiality agreements." },
  { h: "Cookies", b: "We use essential cookies for site functionality and analytics cookies (e.g., Google Analytics) to understand visitor behavior. You can disable cookies via your browser settings." },
  { h: "Data Retention", b: "We retain lead and client information for as long as necessary to fulfill our services or as required by applicable law." },
  { h: "Your Rights", b: "You may request access, correction, or deletion of your personal data at any time by emailing info@kavionglobal.com." },
  { h: "Contact", b: "Kavion Global Limited, Unit 2904-05, 29/F Universal Trade Ctr, 3 Arbuthnot Rd, Central, Hong Kong. Email: info@kavionglobal.com" },
];

export default function PrivacyPage() {
  return (
    <main data-testid="privacy-page">
      <PageHero eyebrow="Legal" title="Privacy Policy" subtitle="Last updated: February 2026" />
      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          {sections.map((s) => (
            <div key={s.h}>
              <h2 className="font-display text-2xl font-bold text-white">{s.h}</h2>
              <p className="mt-3 text-zinc-400 leading-relaxed">{s.b}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
